import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'
import { cn } from 'utils/cn'

import type { FC, PropsWithChildren } from 'react'

type Props = PropsWithChildren & {
  isDetailedView?: boolean
  status?: AttachmentWithUploadStatus['status']
}

export const MessageResourceTagLayoutWrapper: FC<Props> = ({ children, isDetailedView, status }) => (
  <div
    className={cn(
      'flex justify-between gap-x-2 items-center bg-default border box-border border-light rounded-xl shadow-sm',
      {
        'p-2 lg:p-3': isDetailedView,
        'h-11 p-1.5 rounded-lg gap-x-0 ': !isDetailedView,
        'opacity-50': status === 'deleting',
        'bg-subdued border-none shadow-none': status === 'uploading',
        'border-danger/70 bg-danger/70 shadow-none': status === 'error',
      },
    )}
  >
    {children}
  </div>
)
